import { Request } from 'commons/utils/request'

import { ApplicationChangesDetailsWebPage } from './types'

export const getApplicationChangesDetailsWebPage = (id: number) =>
  Request.post<ApplicationChangesDetailsWebPage>(Request.urls.bank.applicationWarningsDetails, {
    id
  })

export const patchApplicationAcknowledgeWarnings = (id: number) =>
  Request.patch(Request.urls.bank.applicationAcknowledgeWarnings, { id })
